// Typed search params for leads returning from the Customer.io audit drip
// (emails 2-4 link back here with their own audit results attached).
export interface AuditReturnParams {
  store_url?: string;
  score?: string;
  top_fail?: string;
  name?: string;
}

export function validateAuditReturnSearch(input: Record<string, unknown>): AuditReturnParams {
  const out: AuditReturnParams = {};
  const storeUrl = input.store_url;
  if (typeof storeUrl === "string" && storeUrl.length > 0 && storeUrl.length <= 200) {
    out.store_url = storeUrl;
  }
  const score = input.score;
  if (typeof score === "string" && /^\d{1,3}$/.test(score) && Number(score) <= 100) {
    out.score = score;
  }
  const topFail = input.top_fail;
  if (typeof topFail === "string" && topFail.length > 0 && topFail.length <= 120) {
    out.top_fail = topFail;
  }
  const name = input.name;
  if (typeof name === "string" && name.length > 0 && name.length <= 60) {
    out.name = name;
  }
  return out;
}

export function auditReturnHostname(storeUrl: string): string {
  try {
    return new URL(storeUrl).hostname.replace(/^www\./, "");
  } catch {
    return storeUrl;
  }
}
